<template>
    <v-main>
        <lbls>ROUTE wrapper @/src/views/admin/Index.vue</lbls>
        <AdminPanel v-if="$prms(['director','admin'])" />
    </v-main>
</template>

<script>
  import {
    mapState,
    mapActions, mapMutations
  } from 'vuex'
  import AdminPanel from "../a4l/playercomponents/AdminPanel";
  import Lbls from "../../components/Lbls";

  export default {
    name: "Index",
    components: {Lbls, AdminPanel},
    data() {
      return {
        profile: undefined
      }
    },
    computed: {
      ...mapState(['activeplayer','athleteobject'])
    },
    created() {
      if(this.athleteobject[this.$route.params.playerkey]){
        //speeds up loading for any recent profiles
        let p = this.athleteobject[this.$route.params.playerkey]
        this.profile = Object.assign({},p)
        console.log('createdhook',p,this.profile)
        this.setActivePlayer(p)
      }
      this.selectPlayer(this.$route.params.playerkey)
    },
    methods: {
      ...mapActions(['get', 'post','selectPlayer']),
      ...mapMutations(['setActivePlayer']),
    }
  }

</script>

<style scoped>

</style>